export default "__VITE_ASSET__bf683cd4__"